import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AppStateService, UserAccessService } from '@siza-staff-care/shared/app-state';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard {
	constructor(
		private router: Router,
		private appState: AppStateService,
		private userAccess: UserAccessService,
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.isAuthenticated()) {
			return true;
		}

		const requestedUrl = state.url;
		this.appState.setRedirectAfterLogonUrl(requestedUrl);

		this.router.navigate(['/login']);
		return false;
	}

	private isAuthenticated() {
		return this.appState.isAuthenticated;
	}
}
